var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"2.70711","y1":"1.29289","x2":"32.7071","y2":"31.2929","stroke":"black","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"1.29289","y1":"31.2929","x2":"31.2929","y2":"1.29289","stroke":"black","strokeWidth":"2","key":1})]);
}

Cross.defaultProps = {"width":"34","height":"32","viewBox":"0 0 34 32","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
